<template>
  <section class="hero">
    <vueVimeoPlayer ref="player"
                    :video-id="videoId"
                    :options="{background: true, responsive: true}"
                    autoplay="true"
                    loop="true"
                    controls="false"
                    class="hero-video"/>
    <img :src="this.$options.image"
         class="hero-image"/>
    <div class="hero-overlay">
      <h1 v-html="text"></h1>
      <p v-if="subtext" v-text="subtext"></p>
      <slot/>
    </div>
  </section>
</template>

<script>
import { vueVimeoPlayer } from 'vue-vimeo-player';

export default {
  name: 'HeroTextSection',
  components: {
    vueVimeoPlayer
  },
  props: {
    text: String,
    subtext: String,
    videoId: String,
    imageName: String
  },
  created () {
    this.$options.image = require(`../../assets/${this.imageName}`);
  }
};
</script>>
